import React, { useEffect, useState } from 'react'
import { Typography, Box } from '@mui/material'
import Skeleton from 'react-loading-skeleton'
import Api from '../../../../_helpers/Api'
import { trans } from '../../../../_providers/Translation'
import { LineChart } from '@mui/x-charts'

function TimeSeriesChart({
    title,
    apiEndpoint
}) {
    const [loading, setLoading] = useState(true)
    const [chartData, setChartData] = useState([])
    const [days, setDays] = useState([])
    const [partners, setPartners] = useState([])
    const [filters, setFilters] = useState({ partner: "" })

    useEffect(() => {
        setLoading(true)

        const endpointWithFilterParams = `${apiEndpoint}?partner=${filters.partner}`

        Api.get(endpointWithFilterParams)
            .then(res => {
                if (res.data) {
                    setChartData(res.data.data.chartData || [])
                    setDays(res.data.data.days || [])
                    setPartners(res.data.data.partners || [])
                }
                setLoading(false)
            })
            .catch(() => setLoading(false))
    }, [filters])

    const series = chartData.map((item, index) => ({
        curve: "linear",
        data: item.data,
        area: true,
        color: item.color,
        label: item.name,
        showMark: true,
        id: `series-${index}`,
    }))

    function getIfAnyData() {
        return chartData.some(
            (item) => item.data.some((point) => point > 0)
        )
    }

    function onFilterChange(e) {
        const { name, value } = e.target

        setFilters((prev) => ({
            ...prev,
            [name]: value,
        }))
    }

    return (
        <div className='pannel'>
            <div className='customers-chart'>
                <div className='head'>
                    <h3>
                        {title}
                    </h3>
                    <select
                        onChange={onFilterChange}
                        name="partner"
                        value={filters.partner}
                    >
                        <option value="">{trans('random.allPartners')}</option>
                        {partners.map((partner) => (
                            <option key={partner.id} value={partner.id}>
                                {partner.name}
                            </option>
                        ))}
                    </select>
                </div>
                <hr />
                {loading ?
                    <Skeleton height={220} count={1} />
                    :
                    !getIfAnyData() ?
                        <div
                            className="alert info"
                            style={{
                                width: "100%",
                                marginBottom: "auto",
                            }}
                        >
                            {trans("messages.noDataFound")}
                        </div>
                        :
                        <LineChart
                            xAxis={[{
                                data: days,
                                scaleType: 'point',
                            }]}
                            series={series}
                            height={287}
                            grid={{ horizontal: true }}
                            sx={{
                                '& .MuiAreaElement-root': {
                                    opacity: 0.3,
                                },
                                '& .MuiLineElement-root': {
                                    strokeWidth: 2,
                                },
                                '& .MuiMarkElement-root': {
                                    stroke: '#fff',
                                    strokeWidth: 1,
                                    r: 5,
                                },
                                '& .MuiChartsGrid-line': {
                                    stroke: '#e0e0e0',
                                    strokeDasharray: '4 2',
                                },
                            }}
                            slotProps={{
                                legend: { hidden: true }
                            }}
                        />
                }
            </div>
        </div>
    )
}

export default TimeSeriesChart
